import { ICON_TYPES } from '../constants';

export const ArrowUp = (): JSX.Element => {
  return (
    <svg
      width="20"
      height="25"
      viewBox="0 0 20 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.112 8.96494L11.957 1.80994C11.3319 1.18504 10.4842 0.833984 9.60029 0.833984C8.71641 0.833984 7.86872 1.18504 7.24362 1.80994L0.088623 8.96494L2.44529 11.3216L7.93362 5.83327V24.1666H11.267V5.83327L16.7553 11.3216L19.112 8.96494Z"
        fill="#008558"
      />
    </svg>
  );
};

ArrowUp.iconType = ICON_TYPES.ARROW_UP;
